import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import LaunchIcon from '@mui/icons-material/Launch';
import { useTheme } from '@mui/material/styles';
import { useQuery } from '../hooks/useQuery';
import { decryptData, handleHttpError } from '../utils';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from '../hooks/useSnackbar';
import {
  CircularProgress,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

export default function DetalheNotaFiscalStep4() {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  let { nota_fiscal_id } = useParams();
  const theme = useTheme();

  const { listarArquivosNotaFiscal } = useQuery();

  const [isLoading, setIsLoading] = React.useState(true);
  const [files, setFiles] = React.useState([]);

  React.useEffect(() => {
    const id = decryptData(nota_fiscal_id);

    if (!id) {
      navigate(-1);
      return;
    }
    fetchArquivo(id);
  }, []);

  const fetchArquivo = async (id) => {
    try {
      const { data } = await listarArquivosNotaFiscal(id, 'adicional');
      setIsLoading(false);
      setFiles(data.data);
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    }
  };

  const renderContent = () => {
    if (isLoading) return <CircularProgress />;
    if (!isLoading && files.length === 0)
      return <p>Nenhum arquivo encontrado</p>;

    return (
      <>
        {files.map((item) => (
          <ListItem key={item.id}>
            <ListItemButton href={item.link} target="_blank">
              <ListItemIcon>
                <LaunchIcon />
              </ListItemIcon>
              <ListItemText
                primary={item.nome}
                style={{ textDecoration: 'underline' }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </>
    );
  };

  return (
    <Card
      variant="outline"
      style={{
        borderTop: `8px solid ${theme.palette.primary.main}`,
        marginTop: '1.4rem',
      }}
    >
      <CardContent padding="10px">
        <Grid container spacing={1} marginTop={2} display="flex">
          {renderContent()}
        </Grid>
      </CardContent>
    </Card>
  );
}
